import { aclAllowEntityStmtInstruction } from './AclAllowEntityStmt';
import { aclAllowFieldsStmtInstruction } from './AclAllowFieldsStmt';
import { aclDenyEntityStmtInstruction } from './AclDenyEntityStmt';
import { aclDenyFieldsStmtInstruction } from './AclDenyFieldsStmt';
import { createRoleStmtInstruction } from './CreateRoleStmt';
import { deleteRoleStmtInstruction } from './DeleteRoleStmt';
import { renameRoleStmtInstruction } from './RenameRoleStmt';
export const aclInstruction = `
## ACL Statements
IMPORTANT: Don't define admin role. It is a built-in role that has access to all entities and fields.

### Allow access to all fields of an entity
- accessTypes: read, create, update, delete

${aclAllowEntityStmtInstruction}
${aclDenyEntityStmtInstruction}

### Allow access to specific fields of an entity
- accessTypes: read, create, update
${aclAllowFieldsStmtInstruction}
${aclDenyFieldsStmtInstruction}

### Create and delete roles
${createRoleStmtInstruction}
${deleteRoleStmtInstruction}

### Rename role
${renameRoleStmtInstruction}

`;
//# sourceMappingURL=aclInstruction.js.map